import axiosInstance from "../../api/axiosInstance";

export const fetchAppAdminsAPI = async ({ query = "", page = 1, limit = 100 } = {}) => {
  const params = new URLSearchParams();
  if (query) params.set("query", String(query));
  params.set("page", String(page));
  params.set("limit", String(limit));

  const response = await axiosInstance.get(`users/app-admins?${params.toString()}`);
  return response.data;
};

export const setUserAppAdminStatusAPI = async ({ userId, isAppAdmin }) => {
  const response = await axiosInstance.patch(`users/app-admins/${userId}`, {
    isAppAdmin,
  });
  return response.data;
};
